import { createAppKit } from "@reown/appkit/react";
import { EthersAdapter } from "@reown/appkit-adapter-ethers";
import { defineChain } from "@reown/appkit/networks";

export const CHAIN_ID = Number(process.env.REACT_APP_CHAIN_ID);
const projectId = process.env.REACT_APP_REOWN_PROJECT_ID;

export const robinhoodChain = defineChain({
  id: CHAIN_ID,
  name: process.env.REACT_APP_CHAIN_NAME,
  caipNetworkId: `eip155:${CHAIN_ID}`,
  chainNamespace: "eip155",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: { default: { http: [process.env.REACT_APP_RPC_URL] } },
  blockExplorers: { default: { name: "Blockscout", url: process.env.REACT_APP_EXPLORER_URL } },
});

// Wallet-only modal (no email/social login) — MetaMask + Rabby (injected/EIP-6963) and WalletConnect QR.
export const appKit = createAppKit({
  adapters: [new EthersAdapter()],
  networks: [robinhoodChain],
  defaultNetwork: robinhoodChain,
  projectId,
  metadata: {
    name: "Cross OTC Terminal",
    description: "OTC escrow terminal for large token trades on Robinhood Chain",
    url: typeof window !== "undefined" ? window.location.origin : "",
    icons: [typeof window !== "undefined" ? `${window.location.origin}/cross-logo.png` : ""],
  },
  features: { analytics: false, email: false, socials: [], onramp: false, swaps: false },
  themeMode: "dark",
  themeVariables: {
    "--w3m-accent": "#C026F5",
    "--w3m-color-mix": "#0C0C0F",
    "--w3m-color-mix-strength": 24,
    "--w3m-font-family": "Inter, ui-sans-serif, sans-serif",
    "--w3m-border-radius-master": "2px",
  },
});
